export default "__VITE_ASSET__DAVVdl5d__"